import { render, staticRenderFns } from "./NotificationPreview.vue?vue&type=template&id=00dcb5e2"
import script from "./NotificationPreview.vue?vue&type=script&lang=js"
export * from "./NotificationPreview.vue?vue&type=script&lang=js"
import style0 from "./NotificationPreview.vue?vue&type=style&index=0&id=00dcb5e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports